import { render } from "./ConsultationTriageAssessmentTab.vue?vue&type=template&id=d401a4c0&scoped=true"
import script from "./ConsultationTriageAssessmentTab.vue?vue&type=script&lang=js"
export * from "./ConsultationTriageAssessmentTab.vue?vue&type=script&lang=js"

import "./ConsultationTriageAssessmentTab.vue?vue&type=style&index=0&id=d401a4c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d401a4c0"]])

export default __exports__